import get from 'lodash.get';
import { bool, string, object } from 'prop-types';
import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import classnames from 'classnames';

import MessageBannerCarousel from './MessageBannerCarousel';
import { isPreview, getPreview } from './messageHelpers';

import styles from './MessageBanner-style.scss';

class MessageBanner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            previewMessagesFromUrl: null,
        };
    }

    componentDidMount() {
        const { messages: previewMessages } = getPreview();
        if (previewMessages) {
            this.setState({ previewMessagesFromUrl: previewMessages });
        }
    }

    /**
     * Messages for marketing banner can come from multiple sources and have the following precedence:
     * (1) Preview messages that pulled from a stringfied object on a URL query param
     * (2) Preview messages that are fetched with userType and/or setId from the URL
     * (3) Registered user messages that are fetched with userId
     * (4) Unregistered user messages that are fetched if user is not logged in
     */
    getMessages() {
        const { previewMessagesFromUrl } = this.state;

        if (!this.props.isClient) {
            return { messages: undefined, showAllMessages: false };
        }
        if (previewMessagesFromUrl) {
            return { messages: previewMessagesFromUrl, showAllMessages: true };
        }
        if (get(this.props, 'viewer.previewMessages')) {
            return { messages: this.props.viewer.previewMessages, showAllMessages: false };
        }
        if (!isPreview() && get(this.props, 'user.registeredUserMessages')) {
            return { messages: this.props.user.registeredUserMessages, showAllMessages: false };
        }
        if (!isPreview() && get(this.props, 'viewer.unregisteredUserMessages')) {
            return { messages: this.props.viewer.unregisteredUserMessages, showAllMessages: false };
        }
        return { messages: undefined, showAllMessages: false };
    }

    render() {
        const { isClient, isBelow, isMultiLine, isUserTypeTrade } = this.props;

        const classes = classnames({
            [styles.bannerContainer]: true,
            [styles.isTrade]: isUserTypeTrade,
            [styles.isBelow]: isBelow,
        });

        const { messages, showAllMessages } = this.getMessages();

        if (!isClient || !messages) {
            return <div className={classes} />;
        }

        return (
            <div className={classes}>
                <MessageBannerCarousel
                    messages={messages}
                    showAllMessages={showAllMessages}
                    isMultiLine={isMultiLine}
                />
            </div>
        );
    }
}

MessageBanner.propTypes = {
    hasUserId: bool,
    isBelow: bool,
    isMultiLine: bool,
    isClient: bool,
    isUserTypeTrade: bool,
    relay: object,
    userId: string,
    user: object,
    viewer: object,
};

const mapStateToProps = ({ header }) => {
    const { isUserTypeTrade } = header;

    return {
        isUserTypeTrade,
    };
};

MessageBanner = createFragmentContainer(connect(mapStateToProps)(MessageBanner), {
    user: graphql`
        fragment MessageBanner_user on User {
            registeredUserMessages: bannerMessages @defer {
                ...MessageBannerCarousel_messages
            }
        }
    `,
    viewer: graphql`
        fragment MessageBanner_viewer on Viewer {
            unregisteredUserMessages: messageSet(
                isFirstTimeVisitor: $marketingBannerIsFirstTimeVisitor
            ) @include(if: $isClient) @skip(if: $hasUserId) @defer {
                ...MessageBannerCarousel_messages
            }
            previewMessages: messageSet(
                setId: $marketingBannerPreviewSetId
                userType: $marketingBannerPreviewUserType
            ) @include(if: $hasMarketingBannerPreviewVariables) @defer {
                ...MessageBannerCarousel_messages
            }
        }
    `,
});

export default MessageBanner;
